module.exports = __webpack_public_path__ + "media/npc_dota_hero_sylph.f11e454b.webm";